(function () {
  var STORAGE_KEY = 'phawez_compare';
  var MAX_PRODUCTS = 6;

  var ROWS = [
    { key: 'description',    label: 'Descripción' },
    { key: 'price',          label: 'Precio' },
    { key: 'variants',       label: 'Cantidad' },
    { key: 'type',           label: 'Categoria' },
    { key: 'marca',          label: 'Marca',          meta: true },
    { key: 'acordes',        label: 'Acordes',        meta: true, list: true },
    { key: 'perfil_de_edad', label: 'Perfil de Edad', meta: true, list: true },
    { key: 'concentracion',  label: 'Concentración',  meta: true },
    { key: 'duracion',       label: 'Duración',       meta: true },
    { key: 'proyeccion',     label: 'Proyección',     meta: true },
    { key: 'ocasiones',      label: 'Ocasiones',      meta: true, list: true },
    { key: 'clima_ideal',    label: 'Climas',    meta: true, list: true }
  ];

  var selectedOptions = {};

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveList(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }

    function getCurrentProduct() {
    var el = document.getElementById('phawez-product-meta');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      if (!data || !data.handle) return null;
      return data;
    }
    catch (e) { return null; }
  }

  function isInList(handle) {
    return getList().some(function (p) { return p.handle === handle; });
  }

  function formatPrice(cents) {
    return '$ ' + (cents / 100).toLocaleString('es-CO');
  }

  function pills(arr) {
    if (!arr || !arr.length) return '<span class="phawez-empty-val">—</span>';
    return arr.map(function (v) { return '<span class="phawez-pill">' + v + '</span>'; }).join('');
  }

  function txt(v) {
    if (!v || v === 'null' || v === null || String(v).trim() === '') return '<span class="phawez-empty-val">—</span>';
    return '<span class="phawez-cell-text">' + String(v).trim() + '</span>';
  }

  function renderCell(product, row) {
    var m = product.meta || {};
    if (row.key === 'description') {
      var d = String(product.description || '').replace(/\s+/g, ' ').trim();
      d = d.length > 100 ? d.substring(0, 97) + '...' : d;
      return txt(d);
    }
    if (row.key === 'price') {
      var price = product.selectedPrice || product.price;
      var cap = product.selectedCompareAt || product.compare_at_price;
      if (cap && cap > price) {
        return '<div class="phawez-price-wrap"><span class="phawez-price-sale" id="phawez-price-' + product.handle + '">' + formatPrice(price) + '</span><span class="phawez-price-original" id="phawez-compare-price-' + product.handle + '">' + formatPrice(cap) + '</span></div>';
      }
      return '<span class="phawez-price-normal" id="phawez-price-' + product.handle + '">' + formatPrice(price) + '</span>';
    }
      if (row.key === 'variants') {
      if (!product.options || !product.options.length) return '<span class="phawez-empty-val">—</span>';
      return product.options.map(function (opt, i) {
        return '<div class="phawez-variant-group" style="margin-bottom:4px;"><span style="display:none;">' + opt.name + '</span>'
          + opt.values.map(function (v) {
            return '<button class="phawez-variant-pill" data-handle="' + product.handle + '" data-opt-index="' + i + '" data-value="' + v + '">' + v + '</button>';
          }).join('') + '</div>';
      }).join('');
    }
    if (row.key === 'type') return txt(product.type);
    if (row.meta) return row.list ? pills(m[row.key]) : txt(m[row.key]);
    return '<span class="phawez-empty-val">—</span>';
  }

  function buildModalHTML(products) {
    if (!products || products.length < 2) {
      return '<div class="phawez-modal-empty"><p>Agrega al menos 2 productos para comparar.</p></div>';
    }
    var colgroup = '<colgroup><col class="phawez-col-label">';
    products.forEach(function () { colgroup += '<col class="phawez-col-product">'; });
    colgroup += '</colgroup>';
    var html = '<table class="phawez-compare-table">' + colgroup;
    html += '<tr><td class="phawez-corner"></td>';
    products.forEach(function (p) {
      html += '<td class="phawez-product-header">';
      html += '<div class="phawez-product-img-wrap">';
      html += '<button class="phawez-product-remove" data-handle="' + p.handle + '">×</button>';
      if (p.image) html += '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">';
      html += '</div>';
      html += '<span class="phawez-product-name">' + p.title + '</span>';
      html += '<a href="' + p.url + '" class="phawez-ver-btn">Ver producto</a>';
      html += '</td>';
    });
    html += '</tr>';
    ROWS.forEach(function (row) {
      html += '<tr><td class="phawez-row-label">' + row.label + '</td>';
      products.forEach(function (p) {
        html += '<td>' + renderCell(p, row) + '</td>';
      });
      html += '</tr>';
    });
    html += '</table>';
    setTimeout(function () {
      document.querySelectorAll('.phawez-product-remove').forEach(function (btn) {
        btn.addEventListener('click', function () { removeProduct(this.getAttribute('data-handle')); });
      });
      document.querySelectorAll('.phawez-variant-pill').forEach(function (btn) {
        btn.addEventListener('click', function () { handleVariantClick(this); });
      });
    }, 0);
    return html;
  }

  function handleVariantClick(btn) {
    var handle = btn.getAttribute('data-handle');
    var optIdx = parseInt(btn.getAttribute('data-opt-index'));
    var value = btn.getAttribute('data-value');
    if (!selectedOptions[handle]) selectedOptions[handle] = {};
    selectedOptions[handle][optIdx] = value;
    document.querySelectorAll('.phawez-variant-pill[data-handle="' + handle + '"][data-opt-index="' + optIdx + '"]').forEach(function (b) { b.classList.remove('phawez-variant-pill--active'); });
    btn.classList.add('phawez-variant-pill--active');
    var list = getList();
    var product = list.find(function (p) { return p.handle === handle; });
    if (!product) return;
    var opts = selectedOptions[handle];
    var variant = product.variants.find(function (v) {
      return product.options.every(function (opt, i) { return !opts[i] || v['option' + (i + 1)] === opts[i]; });
    });
    if (!variant) return;
    var priceEl = document.getElementById('phawez-price-' + handle);
    var compareEl = document.getElementById('phawez-compare-price-' + handle);
    if (priceEl) {
      priceEl.textContent = formatPrice(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.className = 'phawez-price-sale';
        if (compareEl) compareEl.textContent = formatPrice(variant.compare_at_price);
      } else {
        priceEl.className = 'phawez-price-normal';
        if (compareEl) compareEl.textContent = '';
      }
    }
  }

  function openModal() {
    var modal = document.getElementById('phawez-modal');
    var overlay = document.getElementById('phawez-modal-overlay');
    var body = document.getElementById('phawez-modal-body');
    if (body) body.innerHTML = buildModalHTML(getList());
    if (modal) modal.classList.add('phawez-modal--open');
    if (overlay) overlay.classList.add('phawez-modal--open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = document.getElementById('phawez-modal');
    var overlay = document.getElementById('phawez-modal-overlay');
    if (modal) modal.classList.remove('phawez-modal--open');
    if (overlay) overlay.classList.remove('phawez-modal--open');
    document.body.style.overflow = '';
  }

    function syncNativeBtn(btn, handle) {
    if (!btn) return;
    var h = handle || (getCurrentProduct() ? getCurrentProduct().handle : null);
    if (!h) return;
    if (isInList(h)) {
      btn.classList.add('active');
      btn.setAttribute('title', 'Quitar de comparación');
    } else {
      btn.classList.remove('active');
      btn.setAttribute('title', 'Agregar a comparar');
    }
  }

  function updateBar() {
    var list = getList();
    var bar = document.getElementById('phawez-bar');
    var slots = document.getElementById('phawez-bar-slots');
    var count = document.getElementById('phawez-count');
    var compareBtn = document.getElementById('phawez-compare-btn');
    if (!bar) return;
    bar.classList.toggle('phawez-bar--visible', list.length > 0);
    if (count) count.textContent = list.length;
    if (compareBtn) compareBtn.disabled = list.length < 2;
    if (slots) {
      var html = '';
      for (var i = 0; i < MAX_PRODUCTS; i++) {
        if (list[i]) {
          html += '<div class="phawez-bar-slot"><img src="' + list[i].image + '" alt="' + list[i].title + '" title="' + list[i].title + '"><button class="phawez-bar-slot-remove" data-handle="' + list[i].handle + '">✕</button></div>';
        } else {
          html += '<div class="phawez-bar-slot phawez-bar-slot--empty">+</div>';
        }
      }
      slots.innerHTML = html;
      slots.querySelectorAll('.phawez-bar-slot-remove').forEach(function (btn) {
        btn.addEventListener('click', function () { removeProduct(this.getAttribute('data-handle')); });
      });
    }
        var nativeBtn = document.querySelector('compare-button');
    if (nativeBtn && getCurrentProduct()) syncNativeBtn(nativeBtn);
  }

  function addProduct(product) {
    var list = getList();
    var existing = list.findIndex(function (p) { return p.handle === product.handle; });
    if (existing !== -1) { list[existing] = product; saveList(list); updateBar(); return; }
    if (list.length >= MAX_PRODUCTS) { alert('Máximo ' + MAX_PRODUCTS + ' productos. Quita uno primero.'); return; }
    list.push(product);
    saveList(list);
    updateBar();
  }

  function removeProduct(handle) {
    saveList(getList().filter(function (p) { return p.handle !== handle; }));
    updateBar();
    var modal = document.getElementById('phawez-modal');
    var body = document.getElementById('phawez-modal-body');
    if (modal && modal.classList.contains('phawez-modal--open') && body) {
      body.innerHTML = buildModalHTML(getList());
    }
  }

  window.phawezClearCompare = function () {
    localStorage.removeItem(STORAGE_KEY);
    updateBar();
    closeModal();
  };

  function init() {
    updateBar();
        // Interceptar botón nativo de comparar de Wokiee en página de producto
setTimeout(function () {
  var nativeBtn = document.querySelector('compare-button');
  if (!nativeBtn) return;
  syncNativeBtn(nativeBtn);
  nativeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var current = getCurrentProduct();
    if (!current) return;
    if (isInList(current.handle)) {
      removeProduct(current.handle);
    } else {
      addProduct(current);
    }
    syncNativeBtn(nativeBtn);
  }, true);
}, 800);
                // Interceptar botones compare del grid directamente
    setTimeout(function () {
      if (document.getElementById('phawez-product-meta')) return;
      document.querySelectorAll('compare-button').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          var handle = btn.getAttribute('data-product-handle');
          if (!handle) return;
          if (isInList(handle)) {
            removeProduct(handle);
            btn.classList.remove('active');
            btn.setAttribute('title', 'Agregar a comparar');
          } else {
            fetch('/products/' + handle + '.js')
              .then(function (r) { return r.json(); })
              .then(function (p) {
                var image = p.images && p.images.length > 0 ? p.images[0] : '';
                addProduct({
                  handle: p.handle,
                  title: p.title,
                  image: image,
                  price: p.variants[0].price,
                  compare_at_price: p.variants[0].compare_at_price,
                  url: '/products/' + p.handle,
                  description: p.body_html ? p.body_html.replace(/<[^>]+>/g, '') : '',
                  type: p.product_type,
                  options: p.options,
                  variants: p.variants,
                  meta: {}
                });
                btn.classList.add('active');
                btn.setAttribute('title', 'Quitar de comparación');
              });
          }
        }, true);
      });
    }, 1000);

    // Sincronizar estado visual de todos los botones del grid al cargar
    setTimeout(function () {
      document.querySelectorAll('compare-button').forEach(function (btn) {
        var handle = btn.getAttribute('data-product-handle');
        if (!handle) return;
        if (isInList(handle)) {
          btn.classList.add('active');
          btn.setAttribute('title', 'Quitar de comparación');
        } else {
          btn.classList.remove('active');
          btn.setAttribute('title', 'Agregar a comparar');
        }
      });
    }, 600);
    var clearBtn = document.getElementById('phawez-bar-clear');
    if (clearBtn) clearBtn.addEventListener('click', phawezClearCompare);
    var compareBtn = document.getElementById('phawez-compare-btn');
    if (compareBtn) compareBtn.addEventListener('click', openModal);
    var closeBtn = document.getElementById('phawez-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    var overlay = document.getElementById('phawez-modal-overlay');
    if (overlay) overlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    window.addEventListener('storage', function (e) { if (e.key === STORAGE_KEY) updateBar(); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();